import { LoginRequest, LoginRequestPlatformEnum, LoginResponse, MenuItem, PermissionType } from '../../../domain/models/session/session';

type MockUser = {
    user_id: number;
    username: string;
    email: string;
    password: string;
    employee_id?: number;
    role_id: number;
    role_name: string;
};

const users: MockUser[] = [
    {
        user_id: 1,
        username: 'jperez',
        email: 'admin@klab.local',
        password: 'Admin123!',
        employee_id: 1,
        role_id: 1,
        role_name: 'Administrador',
    },
    {
        user_id: 2,
        username: 'agent01',
        email: 'customer@klab.local',
        password: 'Customer123!',
        employee_id: 2,
        role_id: 2,
        role_name: 'Agente',
    },
];

const lockedUserEmail = 'locked@empresa.com';
const serverErrorEmail = '500@empresa.com';
const networkErrorEmail = 'net@empresa.com';

let currentMockUserId: number | undefined;

export const authSdkMock = {
    login(payload: LoginRequest): LoginResponse {
        const email = (payload?.email ?? '').trim().toLowerCase();
        const pass = payload?.password ?? '';

        if (email === lockedUserEmail) {
            throw { status: 401, message: 'Cuenta bloqueada temporalmente' };
        }

        if (email === serverErrorEmail) {
            throw { status: 500, message: 'Error interno del servidor' };
        }

        if (email === networkErrorEmail) {
            throw { status: 0, message: 'Error de red' };
        }

        const found = users.find((u) => u.email.toLowerCase() === email && u.password === pass);

        if (!found) {
            throw { status: 401, message: 'Credenciales incorrectas' };
        }

        currentMockUserId = found.user_id;
        const platform = payload.platform ?? LoginRequestPlatformEnum.Web;

        return {
            token: {
                access_token: `mock_access_${platform}_${found.user_id}`,
                refresh_token: `mock_refresh_${platform}_${found.user_id}`,
                token_type: 'Bearer',
                expires_in: 3600,
            },
            user: {
                user_id: found.user_id,
                username: found.username,
                email: found.email,
                employee_id: found.employee_id,
                role: { role_id: found.role_id, name: found.role_name },
            },
            menu: buildMenu(found.role_name),
        };
    },

    validateToken() {
        const u = users.find((x) => x.user_id === currentMockUserId) ?? users[0];
        return {
            success: true,
            data: {
                user: {
                    user_id: u.user_id,
                    username: u.username,
                    email: u.email,
                    employee_id: u.employee_id,
                    role: { role_id: u.role_id, name: u.role_name },
                },
                menu: buildMenu(u.role_name),
            },
        };
    },
};

function buildMenu(roleName: string): MenuItem[] {
    const base: MenuItem[] = [
        {
            permission_id: 1,
            code: 'SOLICITUDES',
            name: 'Solicitudes',
            permission_type: PermissionType.MenuParent,
            icon: 'icon_requests',
            order: 1,
            route: '#',
            children: [
                {
                    permission_id: 101,
                    code: 'REQUESTS-HOURS-JUSTIFICATION',
                    name: 'Justificación de horas',
                    permission_type: PermissionType.MenuItem,
                    icon: undefined,
                    order: 1,
                    route: '/admin/requests/hours-justification',
                    children: [],
                },
                {
                    permission_id: 102,
                    code: 'REQUESTS-OVERTIME',
                    name: 'Horas extra',
                    permission_type: PermissionType.MenuItem,
                    icon: undefined,
                    order: 2,
                    route: '/admin/requests/overtime',
                    children: [],
                },
            ],
        },
    ];

    if (roleName === 'Administrador') {
        base.push({
            permission_id: 2,
            code: 'ADMIN',
            name: 'Administración',
            permission_type: PermissionType.MenuParent,
            icon: 'settings',
            order: 2,
            route: '/admin',
            children: [
                {
                    permission_id: 3,
                    code: 'USERS',
                    name: 'Usuarios',
                    permission_type: PermissionType.MenuItem,
                    icon: 'users',
                    order: 1,
                    route: '/admin/users',
                    children: [],
                },
            ],
        });
    }

    return base;
}
